<ng-container *ngIf="templateContext$ | async as content">
  <div class="container checkout">
    <div class="checkout-header">
      <div class="checkout-header-title">
        <h1>{{ 'checkout.title' | translate }}</h1>
      </div>
    </div>
    <div class="checkout-content">
      <div class="checkout-content-completed">
        <checkout-tabs [items]="tabs"></checkout-tabs>
        <div class="message-success W-100">
          <p class="title">
            {{ ('checkout.title' | translate) + ' #' + content.cart.data?.code + ' ' + ('checkout.completed.message.title' | translate) }}
          </p>
          <div class="message-content">
            <p>
              {{ 'checkout.completed.message.desc' | translate }}
              <a routerLink="/pedidos">{{ 'checkout.completed.message.linkName' | translate }}</a
              >.
            </p>
            <p>{{ 'checkout.completed.message.desc2' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="checkout-content-values">
        <cart-totals [cart]="content.cart.data!" [showButton]="false" />
      </div>
    </div>
  </div>
</ng-container>
